import queryString from 'query-string';
import {
  CREATE_DATA,
  DELETE_DATA,
  GET_DATA_LIST,
  GET_BY_BUDGET_TASK,
  GET_FOR_PO,
  GET_LIST_FILTER_YEAR,
  GET_LIST_FILTER_DEPARTMENT,
  UPDATE_DATA,
  GET_DETAIL,
  CREATE_DATA_PK,
  UPDATE_DATA_PK,
  DELETE_DATA_PK,
} from '@/api/masterData/im-number';

const state = {
  list_data: [],
  list_im: [],
  list_filter_year: [],
  list_filter_department: [],
  list_im: [],
  list_im_po: [],
  detail: null,
  mode: '',
};

const mutations = {
  SET_LIST_DATA: (states, payload) => {
    states.list_data = payload;
  },
  SET_LIST_FILTER_YEAR: (states, payload) => {
    states.list_filter_year = payload;
  },
  SET_LIST_IM: (states, payload) => {
    states.list_im = payload;
  },
  SET_LIST_IM_PO: (states, payload) => {
    states.list_im_po = payload;
  },
  SET_LIST_FILTER_DEPARTMENT: (states, payload) => {
    states.list_filter_department = payload;
  },
  SET_MODE: (states, payload) => {
    states.mode = payload;
  },
  SET_DETAIL: (states, payload) => {
    states.detail = payload;
  },
};

const actions = {
  GET_LIST_DATA: async ({ commit }, query) => {
    query = queryString.stringify(query);
    const resp = await GET_DATA_LIST(query);
    const data = resp.data.data;
    commit('SET_LIST_DATA', data);
  },
  GET_BY_BUDGET_TASK: async ({ commit }, query) => {
    query = queryString.stringify(query);
    const resp = await GET_BY_BUDGET_TASK(query);
    const data = resp.data.data;
    commit('SET_LIST_IM', data);
  },
  GET_FOR_PO: async ({ commit }, query) => {
    query = queryString.stringify(query);
    const resp = await GET_FOR_PO(query);
    const data = resp.data.data;
    commit('SET_LIST_IM_PO', data);
  },
  GET_LIST_FILTER_YEAR: async ({ commit }) => {
    const resp = await GET_LIST_FILTER_YEAR();
    const data = resp.data.data;
    commit('SET_LIST_FILTER_YEAR', data);
  },
  GET_LIST_FILTER_DEPARTMENT: async ({ commit }) => {
    const resp = await GET_LIST_FILTER_DEPARTMENT();
    const data = resp.data.data;
    commit('SET_LIST_FILTER_DEPARTMENT', data);
  },
  CREATE_DATA: ({}, payload) => {
    return CREATE_DATA(payload);
  },
  DELETE_DATA: ({}, payload) => {
    return DELETE_DATA(payload);
  },
  UPDATE_DATA: ({}, payload) => {
    return UPDATE_DATA(payload);
  },
  GET_DETAIL: async ({ commit }, id) => {
    const resp = await GET_DETAIL(id);
    const data = resp.data.data;
    commit('SET_DETAIL', data);
  },
  CREATE_DATA_PK: ({}, payload) => {
    return CREATE_DATA_PK(payload);
  },
  DELETE_DATA_PK: ({}, payload) => {
    return DELETE_DATA_PK(payload);
  },
  UPDATE_DATA_PK: ({}, payload) => {
    return UPDATE_DATA_PK(payload);
  },
};

const getters = {
  listData: (states) => states.list_data,
  listIM: (states) => states.list_im, // for plan relocate
  listIMPO: (states) => states.list_im_po, // for po/expense
  listYear: (states) => states.list_filter_year,
  listDepartment: (states) => states.list_filter_department,
  detail: (states) => states.detail,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
